"use client";

import { c as _c } from "react/compiler-runtime";
;
!function () {
  try {
    var e = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : {};
    e._sentryModuleMetadata = e._sentryModuleMetadata || {}, e._sentryModuleMetadata[new e.Error().stack] = Object.assign({}, e._sentryModuleMetadata[new e.Error().stack], {
      "_sentryBundlerPluginAppKey:propstrata-app": true
    });
  } catch (e) {}
}();
import { useMutation } from "@tanstack/react-query";
import { useParams, usePathname, useRouter } from "next/navigation";
import { useCallback, useMemo } from "react";
import { toast } from "sonner";
import { controlEditWorkspace } from "@/components/settings/workspace/EditWorkspaceDialog";
import { useIsSharedView } from "@/contexts/SharedViewContext";
import { useUserData } from "@/hooks/useUserData";
import { logger } from "@/lib/services/logger";
import { getWorkspacesDefaultViewPath } from "@/lib/utils";
import { getQueryClient } from "@/queries/config/query-client";
import { workspaceMutationKeys } from "@/queries/query-keys/workspace";
import { editWorkspace } from "@/queries/workspace/updates";

/**
 * Hook to get the current workspace instance
 * @returns The current workspace instance
 */
export function useCurrentWorkspace() {
  const $ = _c(27);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = getQueryClient();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const queryClient = t0;
  const pathname = usePathname();
  const {
    workspaceId: t1,
    view
  } = useParams() as {
    workspaceId: string;
    view: string;
  };
  const workspaceId = t1 === undefined ? "" : t1;
  const isSharedView = useIsSharedView();
  const {
    workspaces,
    loading,
    queryOptions
  } = useUserData(isSharedView ? "shared-view-skip" : undefined);
  const router = useRouter();
  let t2;
  if ($[1] !== pathname || $[2] !== workspaceId) {
    t2 = pathname.split(`/${workspaceId}/`).pop();
    $[1] = pathname;
    $[2] = workspaceId;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const headerNameFromPathname = t2;
  const currentView = decodeURIComponent(view ? decodeURIComponent(view) : decodeURIComponent(headerNameFromPathname ?? ""));
  let t3;
  bb0: {
    if (!workspaceId) {
      t3 = null;
      break bb0;
    }
    let t4;
    if ($[4] !== workspaceId || $[5] !== workspaces) {
      t4 = workspaces.find(workspace => workspace.id === workspaceId) ?? null;
      $[4] = workspaceId;
      $[5] = workspaces;
      $[6] = t4;
    } else {
      t4 = $[6];
    }
    t3 = t4;
  }
  const workspace_0 = t3;
  let t4;
  if ($[7] !== router || $[8] !== workspaces) {
    t4 = workspaceIdToSet => {
      const defaultUpdateWorkspaceView = getWorkspacesDefaultViewPath(workspaces, workspaceIdToSet);
      router.push(defaultUpdateWorkspaceView);
    };
    $[7] = router;
    $[8] = workspaces;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const updateCurrentWorkspace = t4;
  let t5;
  if ($[10] !== workspaceId) {
    t5 = workspaceMutationKeys.settingsEdit(workspaceId);
    $[10] = workspaceId;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== queryOptions) {
    t6 = async () => {
      await queryClient.invalidateQueries({
        queryKey: queryOptions.queryKey,
        refetchType: "all"
      });
      toast.success("Workspace updated");
      controlEditWorkspace({
        state: "off"
      });
    };
    $[12] = queryOptions;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t5 || $[15] !== t6) {
    t7 = {
      mutationFn: editWorkspace,
      mutationKey: t5,
      onError: _temp,
      onSuccess: t6
    };
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  const {
    mutateAsync: updateWorkspaceInformation,
    isPending: isUpdatingWorkspaceInformation
  } = useMutation(t7);
  const t8 = workspace_0?.name;
  const t9 = workspace_0?.permissions;
  let t10;
  if ($[17] !== currentView || $[18] !== isUpdatingWorkspaceInformation || $[19] !== loading || $[20] !== t8 || $[21] !== t9 || $[22] !== updateCurrentWorkspace || $[23] !== updateWorkspaceInformation || $[24] !== workspaceId || $[25] !== workspace_0) {
    t10 = {
      currentView,
      isUpdatingWorkspaceInformation,
      loading,
      updateCurrentWorkspace,
      updateWorkspaceInformation,
      workspace: workspace_0,
      workspaceId,
      workspaceName: t8,
      workspacePermissions: t9
    };
    $[17] = currentView;
    $[18] = isUpdatingWorkspaceInformation;
    $[19] = loading;
    $[20] = t8;
    $[21] = t9;
    $[22] = updateCurrentWorkspace;
    $[23] = updateWorkspaceInformation;
    $[24] = workspaceId;
    $[25] = workspace_0;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  return t10;
}
function _temp(error, variables) {
  logger.error("Failed to update workspace", error, {
    variables
  });
  toast.error("Failed to update workspace");
}